import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ErrorOutline } from '@material-ui/icons';
import {
  Button, Dialog, DialogTitle, DialogContent, DialogActions,
} from '../../../common/components';

const S = {
  Dialog: styled(Dialog)`
    .paper {
      width: 480px;
    }
  `,
  Heading: styled.h3`
    margin-bottom: 32px;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
    font-weight: 500;
  `,
  DialogContent: styled(DialogContent)`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  ErrorOutline: styled(ErrorOutline)`
    margin-bottom: 16px;
    color: ${({ theme }) => theme.palette.secondary.main};
    font-size: ${({ theme }) => theme.typography.pxToRem(48)};
  `,
  Paragraph: styled.p`
    margin-bottom: 24px;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    text-align: center;
    line-height: 1.53;
  `,
  Button: styled(Button)`
    min-height: 40px;
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
  `,
};

const UploadFailureDialog = ({
  count, initCount, open, onClose,
}) => {
  const handleClose = useCallback(() => {
    onClose();

    initCount();
  }, [initCount, onClose]);
  return (
    <S.Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <S.Heading>연락처 업로드</S.Heading>
      </DialogTitle>
      <S.DialogContent>
        <S.ErrorOutline />
        <S.Paragraph>
          {`총 ${count.total}건 중`}
          <br />
          {`완료 ${count.success}건, 실패 ${count.failure}건`}
        </S.Paragraph>
      </S.DialogContent>
      <DialogActions>
        <S.Button type="submit" color="primary" variant="contained" onClick={handleClose}>
          확인
        </S.Button>
      </DialogActions>
    </S.Dialog>
  );
};

UploadFailureDialog.propTypes = {
  count: PropTypes.shape({
    total: PropTypes.number,
    success: PropTypes.number,
    failure: PropTypes.number,
  }),
  initCount: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

UploadFailureDialog.defaultProps = {
  count: { total: 0, success: 0, failure: 0 },
  onClose: () => {},
};

export default UploadFailureDialog;
